import {AnyEvent, JOB_SECTION_CREATED, JobSectionCreatedEvent} from '../type';

export default function jobSectionCreated(payload: JobSectionCreatedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_CREATED,
    payload,
  }
}